import { render, staticRenderFns } from "./picList.vue?vue&type=template&id=487a82ec"
import script from "./picList.vue?vue&type=script&lang=js"
export * from "./picList.vue?vue&type=script&lang=js"
import style0 from "./picList.vue?vue&type=style&index=0&id=487a82ec&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports